(function () {
  // 构造函数
  function Tandem(baseData, thatEle) {
    this.baseData = $.extend(true, [],baseData);
    this.temData = $.extend(true, [],baseData);
    this.cuEle = "";    // 当前需要插入到页面元素中的字符串
    this.levelArray = [];   // 这里面存储了从第一个层级开始，每个层级选了第几个li
    this.inputElement = thatEle; // 输入框的点击对象
    this.levelName = [];    // 这里面存储了每个层级的选择的li的内容
    this.thatEle = thatEle; // 输入框的点击对象
  }
  Tandem.prototype.init = function() {
    let _this = this;
    // console.log(this,_this.thatEle);
    // 输入框的点击事件
    $(this.thatEle).click(function(){
      // 初始化数据
      _this.cuEle = "";
      _this.levelArray = [];
      _this.levelName = [];
      $(this).nextAll().remove();
      _this.createEle(_this.baseData, 1, $(this));
      // console.log("初始化", _this.baseData)
      // li列表点击事件
      console.log("click")
      _this.thatEle.blur();
      return false;
    });

    $(this.thatEle).parent().off("click", ".level li").on("click",".level li" , function () {
      var index = $(this).attr("index");  // 第几个层级
      var liIndex = $(this).attr("liIndex");  // 点击的第几个li
      var data = "";
      _this.levelArray[index] = liIndex;// 这里面存储了从第一个层级开始，每个层级选了第几个li
      _this.levelName[index-1] = $(this).text(); // 这里面存储了每个层级的选择的li的内容

      // 选中的li添加样式，选中的某个层级下面的层级消失
      $(this).addClass("active").siblings().removeClass("active");
      $(this).parent().parent().nextAll().remove();

      // 重新创建下面的层级
      // if(index == 1){
      //     data = _this.baseData[_this.levelArray[1]];
      //     console.log("1",data, _this.levelArray);
      // }else if(index == 2) {
      //     data = _this.baseData[_this.levelArray[1]].subList[_this.levelArray[2]];
      // }else if(index == 3) {
      //     data = _this.baseData[_this.levelArray[1]].subList[_this.levelArray[2]].subList[_this.levelArray[3]];
      // }else if(index == 4) {
      //     data = _this.baseData[_this.levelArray[1]].subList[_this.levelArray[2]].subList[_this.levelArray[3]].subList[_this.levelArray[4]];
      // }
      // 重新创建下面的层级使用递归来实现
      function digui(data, index, levelList){
        if(levelList.length == 2) {
          // console.log("levelList"+levelList.length)
          return data[levelList[1]];
        }
        if((levelList.length-1) == index) {
          // console.log("levelList"+levelList.length+"     index"+index, data.subList, data.subList[levelList[index]])
          return data.subList[levelList[index]];
        }else if(index == 1) {
          // console.log("levelList"+levelList.length+"     index"+index, data[levelList[1]]);
          return digui(data[levelList[1]], ++index, levelList);
        }else {
          // console.log("levelList"+levelList.length+"     index"+index)
          return digui( data.subList[_this.levelArray[index]], ++index, levelList);
        }
      }

      data = digui(_this.baseData, 1, _this.levelArray);
      // console.log(data, _this.baseData, _this.levelArray, _this.temData);
      // console.log(data, data.subList);
      if(data.subList){
        $(_this.inputElement).attr('code' + index, data.code);
        _this.createEle(data.subList ,parseInt(index)+1 , $(this).parent().parent());
      }else {
        // console.log(CurrentData.inputElement, data, data.code);
        $(_this.inputElement).val($(this).text());
        $(_this.inputElement).attr('code', data.code);
        $(_this.inputElement).nextAll().remove();
        var ele = $(_this.inputElement);
        ele.change();
      }



      // console.log(index, liIndex);
      // console.log($(this).attr("index"));
      return false;
    });

    $(document).click(function () {
      if(_this.inputElement){
        $(_this.inputElement).nextAll().remove();
      }
    });

  }
  Tandem.prototype.createEle = function(data, level, targetEle) {
    this.cuEle = "<div class='level level"+level+"'>";
    this.cuEle = this.cuEle + "<ul>";
    for (var i = 0; i < data.length; i++) {
      this.cuEle = this.cuEle + "<li index='"+level+"' liIndex='"+i+"'>" + data[i].name + "</li>";
    }
    this.cuEle = this.cuEle + "</ul>";
    this.cuEle = this.cuEle + "</div>";

    // console.log(CurrentData.cuEle);
    // 将元素插入页面中
    $(targetEle).after(this.cuEle);
    // console.log($(targetEle));
  };

  $.fn.maturityTandem = function(data) {
    var element = $(this); // 当前的元素
    let cuData = [];
    $.extend(true, cuData, data);

    $(this).each(function () {
      var cum = new Tandem(cuData, this);
      // console.log(cuData);
      cum.init();// 多级联动初始化
    })

  };
})()




// WEBPACK FOOTER //
// ./src/assets/js/maturityTandem.js